import BaseApi from "@/api/baseApi";

export default {
  addOrUpdate(form, context) {
    return BaseApi.post(`/api-master-data/v1/manual-documents?context=${context}`, form);
  },
  cancel(id) {
    return BaseApi.delete(`/api-master-data/v1/manual-documents/cancel/${id}`);
  },
  fetch() {
    return BaseApi.get('/api-master-data/v1/manual-documents');
  },
  fetchById(id) {
    return BaseApi.get(`/api-master-data/v1/manual-documents/${id}`);
  },
  fetchFooter(form) {
    return BaseApi.post(`/api-master-data/v1/manual-documents/footer`, form);
  },
  preview(id) {
    return BaseApi.get(`/api-master-data/v1/manual-documents/print-preview/${id}`);
  },
  print(id) {
    return BaseApi.get(`/api-master-data/v1/manual-documents/print/${id}`);
  },
  remove(id) {
    return BaseApi.delete(`/api-master-data/v1/manual-documents/${id}`);
  }
}
